import debounce from 'lodash/debounce';

/**
 *
 * FinancingForm element for the carpage
 */
class BaseFinancingForm {

  constructor() {
    //Debounced version of the search method, just for recuding unnecessary calls to the server side. Use this one when you can.
    this.debouncedFinancingQuery = debounce(this._financingQuery, 200, { trailing: true, leading: false });
  }

  /**
   * Aborts last made search before the next search is started.
   */
  abortFetch() {
    if( this._controller ) {
      this._controller.abort();
    }
  }

  /**
   * Called before financing query is send, cather financing query parameters here from the HTMLFormElement
   * @protected
   * @param {object} responseJSON financing query response json
   */
  get data() {
    console.log('Implement data() in extending class');
    return {};    
  }

  /**
  * Called after financing query get a server response from Stage ajax interface.
  * This is a good place to update values in the form.
  * @protected
  * @param {object} responseJSON financing query
  */
  _afterSearch( responseJSON ) {
    console.log('Impelement in extending class', responseJSON);
  }

  /**
   * Do financing query to Stage side
   * @protected
   */
  async _financingQuery() {

    this.abortFetch();
    this._controller = new window.AbortController();

    try {
      const response = await this._send( this.data, this._controller );
      const responseJSON = await response.json();
      this._afterSearch(responseJSON);
    } catch( error ) {
      console.warn('Error loading financing data', error );
    }
  }


  /**
   * Send ajax request via fetch API to the Stage
   * @async
   * @param {URLSearchParam} data form data
   * @param {AbortController} controller abort controller signal object
   * @return {Promise} resolved after successful call
   */
  async _send( data, controller ) {
    return await fetch('/stage-ajax/get-finance-info?' + data.toString() ,{
      method: 'GET',
      signal: controller.signal
    })
  }

  /**
   * Called during page load
   */
  /*
  static init() {
    const elements = document.querySelectorAll('.financing-form');

    elements.forEach((element) => {
      new FinancingForm( element );
    });
  }
  */

}


export default BaseFinancingForm;
